import request from '@/utils/request'
import API from './api'

//教辅管理-章节名称 id搜索
export function searchAssistAPI(searchType,data) {
  let url=searchType=='search_id'?API.SEARCH_ASSIST_BY_ID:API.SEARCH_ASSIST_BY_NAME
  return request({
    url: url,
    method: 'post',
    data
  })
}

//教辅管理-问题树
export function getIssueTreeAPI() {
  return request({
    url: API.FRAMEEWORK_KNOWLEDGE_ISSUE_TREE,
    method: 'get'
  })
}

//教辅管理-知识点树
export function getKnowledgeKnowTreeAPI() {
  return request({
    url: API.FRAMEEWORK_KNOWLEDGE_KNOW_TREE,
    method: 'get'
  })
}


//教辅管理-章节列表
export function getSectionListAPI(data) {
  return request({
    url: API.FRAMEEWORK_SECTION_LIST,
    method: 'post',
    data
  })
}


//教辅管理-编辑章节
export function editSectionAPI(data) {
  return request({
    url: API.FRAMEEWORK_SECTION_EDIT,
    method: 'post',
    data
  })
}


//教辅管理-地域树
export function getAreaTreeAPI() {
  return request({
    url: API.FRAMEEWORK_AREA_TREE,
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/API/knowledge-assist-manage.js